import { retrieveAndSetPageLoadTrace } from '@atlassian/jira-retrieve-and-set-page-load-trace/src/index.tsx';
import getMeta from '../get-meta.tsx';
import { fetchIssueData } from './fetchIssueData.tsx';

retrieveAndSetPageLoadTrace(getMeta);

fetchIssueData(window);
